import { useMutation } from '@tanstack/react-query';
import { fetchContent } from '../../../core/queries/course';

function useFetchContent() {
  const { data, isError, error, isSuccess, isPending, mutate } = useMutation({
    mutationKey: ['fetch-content'],
    mutationFn: (data: any) =>
      fetchContent(data.courseId, data.programId, data.contentId),
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
  };
}

export { useFetchContent };
